import React from 'react';
import { Rnd } from 'react-rnd';
import Button from 'react-bootstrap/lib/Button';
import './NonDevice.css';

class NonDevice extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dragging: false,
      resizing: false,
    };
  }

  onDrag = () => {
    setTimeout(() => {
      this.setState({ dragging: true });
    }, 100);
  };

  onDragStop = (e, d) => {
    setTimeout(() => {
      this.setState({ dragging: false });
    }, 100);

    if (this.props.canDrag && (d.x !== this.props.x || d.y !== this.props.y)) {
      this.props.onUpdate({
        x: d.x > 0 ? d.x : 0,
        y: d.y > 0 ? d.y : 0,
      });
    }
  };

  onResize = (e, direction, ref, delta, position) => {
    this.setState({ resizing: true });
    this.props.onUpdate({
      length: ref.style.width.replace('px', '') * 1,
      size: ref.style.height.replace('px', '') * 1,
      ...position,
    });
  };

  onResizeStop = () => {
    setTimeout(() => {
      this.setState({ resizing: false });
    }, 100);
  };

  onClick = () => {
    const { resizing, dragging } = this.state;

    if (resizing || dragging) {
      return false;
    }

    this.props.onClick();
  };

  render() {
    const { width, height, x, y, icon, title, shortKey, className, active, id, canDrag, color, background, fontSize } = this.props;
    const position = { x, y };
    const size = { width, height };
    const cn = active ? 'active' : '';

    return (
      <Rnd
        className={`non-device ${className}`}
        position={position}
        size={size}
        minWidth={50}
        minHeight={50}
        disableDragging={!canDrag}
        enableResizing={!canDrag ? null : {topRight: true, bottomRight: true, right: true}}
        lockAspectRatio={false}
        onDragStop={this.onDragStop}
        onDrag={this.onDrag}
        onResize={this.onResize}
        onResizeStop={this.onResizeStop}
      >
        <Button
          className={`non-device__button ${cn}`}
          style={{color, background, width, height, fontSize: !fontSize || fontSize < 7 ? 12 : fontSize}}
          onClick={this.onClick}
          id={`btn-non-device-${id}`}
        >
          {shortKey && (
            <span className="non-device__shortkey">[{shortKey}]</span>
          )}
          <i className={`non-device__icon ${icon}`}/>
          {title && <span className="non-device__title">{title}</span>}
        </Button>
      </Rnd>
    );
  }
}

export default NonDevice;
